import React from "react";
//import { Step, StepLabel, Stepper, StepButton, StepIcon } from "@mui/material";
import {
  Stepper,
  Step,
  StepLabel,
  StepButton,
  StepIconProps,
  StepConnector,
  stepConnectorClasses,
  useMediaQuery,
} from "@mui/material";

import { Mail, LocationOn, Work, Person, Create, Check } from "@mui/icons-material";

import { styled } from "@mui/material/styles";
import CadastroUsuarioForm from "components/molecules/CadastroUsuarioForm/CadastroUsuarioForm";
import ContatoForm from "components/molecules/ContatoForm/ContatoForm";
import EnderecoForm from "components/molecules/EnderecoForm/EnderecoForm";
import PessoalForm from "components/molecules/PessoalForm/PessoalForm";
import CadastroProfissionaisForm from "components/molecules/CadastroProfissionaisForm/CadastroProfissionaisForm";
import { useCadastro } from "../../../resources/CadastroProvider";
import styles from "./RegistrationPage.module.css";
import CadastroConcluido from "./CadastroConcluido";

const RegistrationPage: React.FC = () => {
  const { steps, activeStepIndex, registrationCompleted } = useCadastro();
  const isMobile = useMediaQuery("(max-width:768px)");

  const stepComponents = [
    <CadastroUsuarioForm key="usuario" />,
    <PessoalForm key="pessoal" />,
    <ContatoForm key="contato" />,
    <EnderecoForm key="endereco" />,
    <CadastroProfissionaisForm key="profissionais" />,
  ];

  /*const handleStepClick = (index: number) => {
    if (index < activeStepIndex) {
      setActiveStepIndex(index);
    }
  };*/

  // Custon Connector
  const CustomConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
      top: 40,
    },
    [`& .${stepConnectorClasses.line}`]: {
      alignItems:'end',
      marginLeft: theme.spacing(3),  // margem esquerda
      marginRight: theme.spacing(3), // margem direita
      height: 0.8,
      border: 0.5,
      backgroundColor: "#2C3D8F", // cinza claro (Tailwind gray-300)
    },
    [`&.${stepConnectorClasses.active} .${stepConnectorClasses.line}`]: {
      backgroundColor: "#2C3D8F", // azul ativo
    },
    [`&.${stepConnectorClasses.completed} .${stepConnectorClasses.line}`]: {
      backgroundColor: "#2C3D8F", // azul quando concluído
    },
  }));

  // Custom component para estilizar os ícones
  function CustomStepIcon(props: StepIconProps) {
    const { icon, active, completed } = props;

    // Ícones customizados de acordo com o número
    const icons: { [index: string]: React.ReactElement } = {
      1: <Mail fontSize="large"/>,
      2: <LocationOn fontSize="large"/>,
      3: <Work fontSize="large"/>,
      4: <Person fontSize="large"/>,
      5: <Create fontSize="large"/>,
    };

    return (
      <div className={styles.stepIconWrapper}>
        <div
          className={
            active
              ? styles.stepIconActive
              : completed
                ? styles.stepIconCompleted
                : styles.stepIcon
          }
        >
        {icons[String(icon)]}
        </div>
        {completed && <Check className={styles.stepCompletedCheck} />}
      </div>
    );
  }

  return (
    <div
      className={styles.registrationContainer}
      data-testid="registrationpage"
    > 
      {/* Card Principal */}
      <div className={styles.card}>
        <Stepper
          activeStep={registrationCompleted ? steps.length - 1 : activeStepIndex}
          alternativeLabel
          orientation="horizontal"
          connector={<CustomConnector />}
          className={styles.stepperRoot}
        >
          {steps.map((step, index) => (
            <Step
              key={index}
              completed={registrationCompleted || step.completed || index < activeStepIndex}
            >
              <StepButton color="inherit" onClick={() => {}}>
                <StepLabel 
                  StepIconComponent={CustomStepIcon}
                  sx={{
                    "& .MuiStepLabel-label": {
                      fontSize: isMobile ? "10px" : "12px",
                      fontWeight: 400,
                      color: "#2B3D8E", // Tailwind gray-700
                      whiteSpace: 'pre-wrap',
                      textAlign: isMobile ? "left" : "center",
                    },
                    "& .Mui-active": {
                      color: "#2B3D8E !important",
                    },
                  }}
                >
                  {step.label}
                </StepLabel>
              </StepButton>
            </Step>
          ))}
        </Stepper>
        <div className={styles.contentWrapper}>
          {registrationCompleted ? <CadastroConcluido /> : stepComponents[activeStepIndex]}
        </div>
      </div>
    </div>
  );
};

export default RegistrationPage;

/*
<Stepper
        activeStep={activeStepIndex}
        alternativeLabel
        className={styles.stepper}
      >
        {steps.map((step, index) => (
          <Step key={index} completed={step.completed}>
            <StepLabel>
              <NavLink
                to={`/cadastro/${index + 1}`}
                className={`${styles.stepLink} ${
                  activeStepIndex === index ? styles.activeStep : ""
                }`}
                onClick={() => handleStepClick(index)}
              >
                <span
                  className={`${styles.stepIcon} ${
                    step.completed ? styles.completedStep : ""
                  }`}
                >
                  {step.completed ? <Check /> : step.icon}
                </span>
                <span>{step.label}</span>
              </NavLink>
            </StepLabel>
          </Step>
        ))}
      </Stepper>
      <div className="w-full mt-6">
        <Outlet />
      </div>


*/
